
import { defineComponent, PropType } from "vue";
import { TrainingCourse } from "../../../../domain/entities/courseEvent/training_course";
import TrainingTableOption from "./TrainingTableOption.vue";
import TransparentButton from "../../components/application/buttons/TransparentButton.vue";
import {
  formatDateOnly,
  formatMenusDates,
  formatMenusSchedule,
  formattedDate,
  getMenusLocation
} from "../../components/mixins";

export default defineComponent({
  name: "MenusDetails",
  components: { TransparentButton, TrainingTableOption },
  methods: {
    getMenusLocation,
    formatMenusDates,
    formatMenusSchedule,
    formatDateOnly,
    formattedDate
  },
  props: {
    course: {
      type: Object as PropType<TrainingCourse>,
      required: true
    },
    numberOfEnrollUsers: {
      type: Number,
      required: true
    }
  },
  setup() {
    const formatEnrolledUsers = (
      maxCapacity: number,
      enrolledUsers: number
    ): string => {
      if (maxCapacity) {
        return `${enrolledUsers}/${maxCapacity}`;
      } else {
        return `${enrolledUsers}`;
      }
    };

    return {
      formatEnrolledUsers
    };
  }
});
